"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = void 0;
const qs_1 = __importDefault(require("qs"));
class Api {
    static async get(url, headers, params) {
        const options = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                ...headers,
            },
        };
        const urlWithQuerystring = params ? `${url}${qs_1.default.stringify(params)}` : url;
        const response = await fetch(urlWithQuerystring, options);
        return (await response.json());
    }
    static async post(url, headers, data) {
        const body = data ? { body: JSON.stringify(data) } : {};
        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...headers,
            },
            ...body,
        };
        const response = await fetch(url, options);
        return (await response.json());
    }
    static async patch(url, headers, data) {
        const body = data ? { body: JSON.stringify(data) } : {};
        const options = {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                ...headers,
            },
            ...body,
        };
        const response = await fetch(url, options);
        return (await response.json());
    }
}
exports.Api = Api;
